import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminAssetTokenConfigsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('asset-token-config');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
